import React from 'react';
import InfoStep from './components/infoStep';
import OtpStep from './components/OtpStep';
import PaymentSummaryStep from './components/PaymentSummaryStep';
import { PlansStep } from './components/PlansStep';


export function SouhoolaLib(props) {
  const {
    step,
    loading,
    plans, 
    amount,
    downPayment,
    installmentSummary,
    handleInfoSubmit,
    handleDownPaymentChange,
    handleInstallmentChange,
    handleConfirmInstallment,
    goToconfirmInstallment,
    handleConfirmTransaction,
    handleResendOtp,
    chosenInstallment
  } = props;

  return (
    <div style={{marginTop:20}}>
      {step === 1 && (
        <InfoStep loading={loading} handleInfoSubmit={handleInfoSubmit} />
      )}
        {step === 2 && (
        <PlansStep
          plans={plans}
          loading={loading}
          handleDownPaymentChange={handleDownPaymentChange}
          handleInstallmentChange={handleInstallmentChange}
          chosenInstallment={chosenInstallment}
          downPayment ={downPayment}
          amount={amount}
          goToconfirmInstallment={goToconfirmInstallment}
        />
      )}
    {step === 3 && (
        <PaymentSummaryStep
          installmentSummary={installmentSummary}
          handleConfirmInstallment={handleConfirmInstallment}
        />
      )}
    {step === 4 && (
        <OtpStep
          loading={loading}
          handleConfirmTransaction={handleConfirmTransaction}
          handleResendOtp={handleResendOtp}
        />
      )}

    </div>
  );
}

export default SouhoolaLib;
